import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import Slider from "infinite-react-carousel";
import Product from "./Product";
import { useEffect, useState } from "react";
import { sendProductList } from "../../services/product/product.service";
import styles from "./Product.module.css";

const ProductCarousel = () => {
  let [products, setProducts] = useState([]);
  let [isMobile] = useState(window.mobileCheck());
  useEffect(() => {
    sendProductList().then(({ data }) => {
      const elems = (data && data.data) || [];
      setProducts(elems);
    });
  }, []);
  return (
    <>
      {products && products.length > 0 ? (
        <div id="product-carousel">
          <div className={styles.productCarouselWrapper}>
            <div className={`hidden-xs hidden-sm ${styles.productListSideBar}`}>
              <div className={styles.titleForSideBar}>
                <div>محصولات</div>
                <img
                  className={styles.productSideBarIcon}
                  src={"/assets/image/producticon.svg"}
                  alt={"ایکن محصولات"}
                />
              </div>
            </div>
            <div className={styles.productSlider}>
              {products && products.length > 0 && isMobile ? (
                <>
                  <div className="container">
                    <div className={styles.productsMobileHeader}>
                      <div className={styles.productsMobileHeaderTitle}>
                        محصولات
                      </div>
                      <div className={styles.iconImageLogo}>
                        <img
                          src={"/assets/image/producticon.svg"}
                          alt={"ایکن محصولات"}
                        />
                      </div>
                      {/* <div className={styles.allProductNews}>
                        <Link to={"/product/list"}>همه محصولات</Link>
                      </div> */}
                    </div>
                  </div>
                  <div className="col-xs-12">
                    <div className={styles.productsMobileWrapper}>
                      {products.slice(0, 5).map((product, index) => {
                        return (
                          <div
                            key={index + "-product-item"}
                            className={"carouselItem"}
                          >
                            <Product product={product} />
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </>
              ) : null}
              {products && products.length > 0 && !isMobile ? (
                <>
                  <Slider
                    className={styles.productSliderDesktop}
                    slidesToShow={3}
                    arrowsScroll={1}
                    swipe={true}
                    duration={200}
                    centerMode={true}
                    autoplay={false}
                    dots={true}
                    centerPadding={20}
                    dotsScroll={1}
                    overScan={0}
                    appendDots={(dots) => (
                      <ul style={{ display: "block" }}>{dots.reverse()}</ul>
                    )}
                    prevArrow={
                      <button className={styles.prevCarousel}>
                        <i className="fa fa-angle-left"></i>
                      </button>
                    }
                    nextArrow={
                      <button className={styles.nextCarousel}>
                        <i className="fa fa-angle-right"></i>
                      </button>
                    }
                  >
                    {[...products.slice(0, -1)]
                      .reverse()
                      .map((product, index) => {
                        return (
                          <div
                            key={`${index}-product-item`}
                            className={"carouselItem"}
                          >
                            <Product product={product} />
                          </div>
                        );
                      })}
                  </Slider>
                </>
              ) : null}
            </div>
          </div>
        </div>
      ) : (
        <div className="loading-wrapper">
          <img
            src={"../../../assets/image/loading.svg"}
            alt={"در حال بار گذاری"}
          />
        </div>
      )}
    </>
  );
};

export default ProductCarousel;
